import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventService } from '../../../core/services/event.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import * as _ from "lodash";
import { NgForm } from '@angular/forms';

@Component({
    selector: 'main-tab-email',
    templateUrl: './email.component.html',
    styleUrls: ['../profile.page.scss']
})
export class EmailComponent implements OnInit {
    @Output() onFormAdd = new EventEmitter();
    @Input() dictData: any;
    form: NgForm;

    model: any;
    state: any = {
        isSubmitted: false
    };

    isCreation: boolean;
    isFormVisible: boolean = false;
    editModel: any;

    @ViewChild('form') set content(content: NgForm) {
        this.form = content;
    }

    constructor(
        private eventService: EventService,
        private http: HttpClient,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
    }

    convertToModels(gqlRes) {
        let constituent = gqlRes.Participant[0].individualConstituent;
        this.model = {
            emails: []
        };

        constituent.constituentEmails.forEach(email => {
            this.model.emails.push({
                constituentEmailID: email.constituentEmailId,
                email: email.email,
                emailType: {
                    emailTypeID: email.emailType.cmgmtEmailTypeId,
                    name: email.emailType.name,
                    description: email.emailType.description
                },
                primary: email.primaryFl
            });
        });
    }

    /** Edit/create **/
    cancel() {
        this.isFormVisible = false;
        this.editModel = null;
        this.state.isSubmitted = false;
    }

    create() {
        this.isCreation = true;
        this.isFormVisible = true;
        this.editModel = {
            emailType: {},
            primary: false
        };
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    edit(email) {
        this.isCreation = false;
        this.isFormVisible = true;
        this.editModel = _.cloneDeep(email);
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    validatePrimaryEmail() {
       if (this.editModel.primary) {
          return true;
       }
       let hasPrimaryEmail: boolean = false;

       this.model.emails.forEach(email => {
        if (email.constituentEmailID != this.editModel.constituentEmailID) {
           if (email.primary) {
             hasPrimaryEmail = true;
           }
        }
       });

       return hasPrimaryEmail;
    }

    save() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;

        if (!this.validatePrimaryEmail()) {
          this.toastr.error("There should be a primary email set");
          return;
        }

        this.form.form.markAsPristine();
        if (this.isCreation) {
            this.http.post('/api/v1/user/emails', this.editModel)
                .subscribe(res => {
                    this.eventService.getEmails(true).subscribe(() => {});
                    this.toastr.success('Email added.');
                }, err => {
					this.toastr.error("There was a problem creating the email");
				});
        } else {
            this.http.post('/api/v1/emails/' + this.editModel.constituentEmailID, this.editModel)
                .subscribe(res => {
                    this.eventService.getEmails(true).subscribe(() => {});
                    this.toastr.success('Email updated.');
                }, err => {
					this.toastr.error("There was a problem updating the email");
				});
        }
        this.isFormVisible = false;
        this.state.isSubmitted = false;
    }

    delete(email) {
        this.http.delete('/api/v1/emails/' + email.constituentEmailID)
            .subscribe(res => {
                this.eventService.getEmails(true).subscribe(() => {});
                this.toastr.success('Email deleted.');
            });
    }
}

